function buildStats(s) {
  const smallMediumTotal = Object.entries(s.vehicle_counts || {})
    .filter(([k]) => !["trailer_40ft", "semi_bed_40ft", "hydraulic_axle"].includes(k))
    .reduce((sum, [, n]) => sum + (n || 0), 0);

  return [
    { label: "Total Vehicles", value: s.total_vehicles, hi: true },
    { label: "40ft Trailers", value: s.trailer_40ft_count },
    { label: "40ft Semi Bed", value: s.semi_bed_40ft_count },
    { label: "Hydraulic Axle", value: s.hydraulic_axle_count || 0 },
    { label: "Small / Medium Trucks", value: smallMediumTotal },
    { label: "ODC Cases", value: s.odc_case_count || 0, warn: (s.odc_case_count || 0) > 0, warnColor: "#F97316" },
    { label: "RTO Permits", value: s.odc_permit_count || 0, warn: (s.odc_permit_count || 0) > 0, warnColor: "#F97316" },
    { label: "Unassigned", value: s.unassigned_count, warn: s.unassigned_count > 0 },
  ];
}

function statValueClass(st) {
  if (st.hi) return "text-3xl text-[#2563EB]";
  if (st.warn) return "text-2xl";
  return "text-2xl text-white";
}

export default function SummaryStats({ summary }) {
  const stats = buildStats(summary || {});
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 border border-slate-200 bg-[#F8FAFC]">
      {stats.map((st, i) => (
        <div
          key={st.label}
          className={`p-5 border-slate-200 ${i < stats.length - 1 ? "border-r" : ""} ${
            i < 4 ? "md:border-b-0 border-b" : ""
          } md:border-r`}
          data-testid={`stat-${st.label.toLowerCase().replace(/\s/g, "-")}`}
        >
          <div className="overline mb-2">{st.label}</div>
          <div
            className={`mono font-semibold ${statValueClass(st)}`}
            style={st.warn ? { color: st.warnColor || "#EF4444" } : {}}
          >
            {st.value ?? 0}
          </div>
        </div>
      ))}
    </div>
  );
}
